import { memo } from 'react';
import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants';
import { DamperType, UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { getActuatorBreadcrumbValues } from '../hooks/getActuatorBreadcrumbValues';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    locale: LocalesEnum;
    selectedActuatorType: ActuatorTypes;
}

export const ActuatorTooltipValue = memo(({ region, state, locale, selectedActuatorType }: Props) => {
    const {
        damper,
        area,
        diameter,
        blade,
        roundDumper,
        airflow,
        damperRequired,
        safety,
    } = getActuatorBreadcrumbValues({ region, state, locale, selectedActuatorType });

    const rectangularAmResults = [damper, area, blade, airflow, damperRequired];
    const roundAmResults = [damper, area, airflow, damperRequired];
    const rectangularEuResults = [damper, area, blade, safety];
    const roundEuResults = [damper, diameter, roundDumper, safety];

    const results = {
        [DamperType.Rectangular]: region === RegionsEnum.Am ? rectangularAmResults : rectangularEuResults,
        [DamperType.Round]: region === RegionsEnum.Am ? roundAmResults : roundEuResults,
    };

    return (
        <div className="vss-actuator-tooltip-value">
            {results[state.damper].map(([label, value], i) => (value ? (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className="vss-actuator-tooltip-value__row">
                    <p className="vss-actuator-tooltip-value__label">
                        {label}
                    </p>

                    <p className="vss-actuator-tooltip-value__value">{value}</p>
                </div>
            ) : null))}
        </div>
    );
});
